import CustomAutomationsAPI from 'dashboard/api/customAutomations';

// Dispatch a frontend-originated event to the server, which evaluates the
// matching custom_automation_rules and executes their actions
// (Dotchat::CustomAutomationService). Fire-and-forget.
export const runCustomAutomations = (eventName, context = {}) =>
  CustomAutomationsAPI.dispatch(eventName, context).catch(() => {});
